export default class Service {
  constructor(item, lang) {
    this._setId(item);
    this._setImage(item, lang);
    this._setDescription(item, lang);
    this._setTitle(item.serviceType, lang);
    this._setIcon(item.serviceType);
  }

  _setId({ id }) {
    this.id = id;
  }

  _setImage({ photoUrl }) {
    this.image = photoUrl;
  }

  _setTitle(item, lang) {
    let key = "name_" + lang;
    this.title = item[key];
  }

  _setDescription(item, lang) {
    let key = "description_" + lang;
    this.description = item[key];
  }

  _setIcon(serviceType) {
    this.svgCode = (serviceType && serviceType.svgCode) || null;
    this.iconUrl = (serviceType && serviceType.photoUrl) || null;
    this.iconColor = (serviceType && serviceType.iconColor) || null;
  }
}
